<template lang="html">
  <div>
    <v-row v-if="!showProfile">
      <v-col cols="12">
        <v-card>
          <v-card-actions>
            <v-row>
              <v-col
                cols="8"
              >
                <v-text-field
                  v-model="search"
                  placeholder="Key in course name here"
                  append-icon="search"
                  label="Search course"
                  hide-no-data
                  hide-selected
                  clearable 
                />
              </v-col>
            </v-row>
          </v-card-actions>

          <v-tabs
            v-model="active"
            color="black"
            class="pl-3"
          >
            <v-tab>
              All
            </v-tab>
          </v-tabs>

          <v-tabs-items 
            v-model="active"
          >
            <v-row class="overflow">
              <v-col
                v-for="(course,i) in courses"
                :key="i"
                cols="3"
                class=""
              >
                <v-card
                  class="mx-auto px-0"
                  max-width="370"
                  @click="openProfile(course)"
                >                
                  <v-img
                    :src="course.image_url"
                    height="194"
                  />

                  <v-list-item>
                    <v-list-item-content>                      
                      <v-list-item-title class="mb-1 font-weight-bold text-truncate">
                        {{ course.name }}
                      </v-list-item-title>
                      <v-list-item-subtitle class="text-truncate">
                        {{ course.description }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-card-text class="pt-0">                   
                    <v-chip>
                      {{ course.classroom_type.name }}
                    </v-chip>
                  </v-card-text>        
                </v-card>
              </v-col>
            </v-row>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>

    <setup-training-participants-container-view
      v-if="showProfile"
      :course-id="course.id"
    >
      <template v-slot:navigation>
        <v-breadcrumbs 
          :items="navItems" 
          divider="/"
          class="py-0"
        >
          <template v-slot:item="props">
            <a  
              :class="{ 
                'disabled': props.item.disabled, 
              }"       
              @click="updatePage"
            >{{ props.item.text }}</a>
          </template>
        </v-breadcrumbs>
      </template>
    </setup-training-participants-container-view>
  </div>
</template>

<script>

  export default {
    components: {
      SetupTrainingParticipantsContainerView: () => import('@/components/setup/training/participants/ContainerView'),
    },

    data () {
      return {
        navItems: [
          {
            text: 'Overview',
            disabled: false,
            to: { path: '/courses' }, 
            exact: true,
          },
          {
            text: 'Profile',
            disabled: true,
          },
        ],

        active: 0,   
        loading: false,
        courses: [],
        search: null,
        showProfile: false,
      }
    },
    metaInfo () {
      return {
        title: 'My Course',        
      }
    },

    created () {
      this.loadParticipantCourses()
    },

    methods: {
      updatePage () {
        this.showProfile = false
      },

      openProfile (course) {
        this.course = course
        this.showProfile = true
      },

      loadParticipantCourses () {
        this.$api.participantCourses().list()
          .then(res => {
            this.courses = res.data
          })
      },

      expand (props) {
        props.expand(!props.isExpanded)
        this.active = 0
      },
    },
  }
</script>

<style scoped>
.disabled {
    color: grey;
    pointer-events: none;
}
.overflow {
    height:80vh;
}
</style>
